import { createSlice } from '@reduxjs/toolkit';

const initialRequestParam = {
  customerIds: [],
  limit: -1,
  offset: 0,
  userId: null,
  orderBy: 'expired_at',
  order: 'asc',
};

const initialLineReceptionLists = [];
const initialCounts = {
  totalLineReceotions: 0,
  totalReports: 0,
  totalCompleate: 0,
};

export const getLineReceptionListSlice = createSlice({
  name: 'getLineReceptionList',
  initialState: {
    initialRequestParams: initialRequestParam,
    responseParams: initialLineReceptionLists,
    counts: initialCounts,
  },
  reducers: {
    getLineReceptionList: (state, action) => {
      state.responseParams = action.payload.data.lineReceptions;
      state.counts = {
        totalLineReceptionLists: action.payload.data.total,
        totalReports: action.payload.data.totalReports || 0,
        totalCompleate: action.payload.data.totalCompleate || 0,
      };
    },
    setRequestParams: (state, data) => {
      state.initialRequestParams = data.payload;
    },
    setNotLineReceptionLists: (state) => {
      state.responseParams = initialLineReceptionLists;
      state.counts = initialCounts;
    },
  },
});

export const {
  getLineReceptionList,
  setRequestParams,
  setNotLineReceptionLists,
} = getLineReceptionListSlice.actions;

export default getLineReceptionListSlice.reducer;
